import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards';

import { preferenceResolver } from './shared/modules/localization';
import { environment } from '@env/environment';

const routes: Routes = [
  {
    path: '',
    resolve: {
      lang: () => preferenceResolver(),
    },
    children: [
      {
        path: 'guides',
        loadChildren: () => import('./guides/guides.module').then(m => m.GuidesModule),
      },
      {
        path: 'auth',
        loadChildren: () => import('./core/auth/auth.module').then(m => m.AuthModule),
      },
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: environment.enableRouterTracing,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
